import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Layout from './components/Layout';
import './index.css';
import './styles.css';
import './App.css';

// Import page components
import AI from './pages/ai/AI';
import Tech from './pages/tech/Tech';
import Trading from './pages/trading/Trading';
import Stocks from './pages/stocks/Stocks';
import Religion from './pages/religion/Religion';
import Agri from './pages/agri/Agri';
import Shopping from './pages/shopping/Shopping';
import AITools from './pages/ai-tools/AITools';

// Home page component
function Home() {
  const categories = [
    { name: 'AI Tools', path: '/ai-tools', emoji: '🤖' },
    { name: 'AI & Machine Learning', path: '/ai', emoji: '🧠' },
    { name: 'Technology', path: '/tech', emoji: '💻' },
    { name: 'Trading', path: '/trading', emoji: '📈' },
    { name: 'Stocks', path: '/stocks', emoji: '📊' },
    { name: 'Religion', path: '/religion', emoji: '🙏' },
    { name: 'Agriculture', path: '/agri', emoji: '🌾' },
    { name: 'Shopping', path: '/shopping', emoji: '🛍️' }
  ];

  return (
    <div style={{
      minHeight: '60vh',
      background: 'linear-gradient(135deg, #f8f9fa0%, #dbeafe 50%, #e0e7ff 100%)',
      paddingTop: '2rem',
      paddingBottom: '2rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
    }}>
      <div className="page-wrapper">
        {/* Hero Section */}
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h1 style={{
            fontSize: '2.25rem',
            fontWeight: 'bold',
            color: '#1e293b',
            marginBottom: '1rem',
          }}>Welcome to Minds Log Blogs App</h1>
          <p style={{
            fontSize: '1.125rem', 
            color: '#475569',
            marginBottom: '2rem',
          }}>Your hub for blogs on different topics.</p>
          <div style={{
            height: '4px',
            width: '96px',
            backgroundColor: '#2563eb',
            margin: '0 auto',
            borderRadius: '9999px',
          }}></div>
        </div>

        {/* Categories Section */}
        <div>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#1e293b',
            textAlign: 'center',
            marginBottom: '2rem',
          }}>Browse Categories</h2>
          <div className="categories-grid">
            {categories.map((category) => (
              <a
                key={category.path}
                href={category.path}
                className="category-card"
              >
                <span className="emoji">{category.emoji}</span>
                <h3>{category.name}</h3>
                <p>Explore →</p>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-white">
        <Header />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ai" element={<AI />} />
            <Route path="/tech" element={<Tech />} />
            <Route path="/trading" element={<Trading />} />
            <Route path="/stocks" element={<Stocks />} />
            <Route path="/religion" element={<Religion />} />
            <Route path="/agri" element={<Agri />} />
            <Route path="/shopping" element={<Shopping />} />
            <Route path="/ai-tools" element={<AITools />} />
          </Routes>
        </Layout>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
